/**
 * The editor's inline comment chips (design board "Workspace": "SC · 1 comment" at the end of a commented line), from
 * the file's comment threads as useEditorCollab loads them (`{ id, line, by, replies, resolved }`). One chip per line
 * with open threads: who started the first one, and how many comments (replies included). Resolved threads keep only
 * their glyph in the margin.
 */
export function commentChips(threads, lineCount = Infinity) {
  const byLine = new Map();
  (threads || []).forEach((thread) => {
    if (!thread || thread.resolved || !Number.isInteger(thread.line) || thread.line < 1 || thread.line > lineCount) { return; }
    const entry = byLine.get(thread.line) || { line: thread.line, threadId: thread.id, by: thread.by || null, count: 0 };
    entry.count += 1 + (thread.replies || []).length;
    byLine.set(thread.line, entry);
  });
  return [...byLine.values()]
    .sort((a, b) => a.line - b.line)
    .map((entry) => ({
      ...entry,
      initials: entry.by?.initials || '?',
      slot: entry.by?.slot ?? 0,
      text: `${entry.by?.initials || '?'} · ${entry.count} comment${entry.count === 1 ? '' : 's'}`,
      label: `${entry.count} comment${entry.count === 1 ? '' : 's'} on line ${entry.line}${entry.by?.name ? `, started by ${entry.by.name}` : ''}: open`,
    }));
}
